import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create(
{
    page: {
        display: 'flex',
        marginTop: 32
    },

    title: {
        fontSize: 24,
        color: '#535353',
        fontFamily: 'Montserrat',
        fontWeight: '700',
    },

    text: {
        fontSize: 16,
        color: '#535353',
        fontFamily: 'Montserrat',
        fontWeight: '400',
        marginTop: 32
    },
});